import React from "react";
import { useState } from "react";
import "components/generales/Styles.css";
import MyMoneyLoggedOut from 'components/MyMoney/MyMoneyLoggedOut'
import FormularioLogin from "components/inicio/FormularioLogin";
import "pages/inicio/StylesInicio.css";

const Login = () => {
  const [loginUsuarios, setLoginUsuarios] = useState([]);
  return (
    <>
      <section>
        <div className="imagenContenedor imagenInicio"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <MyMoneyLoggedOut />
            <h2>Iniciar sesión</h2>
            <FormularioLogin
              loginUsuarios={loginUsuarios}
              setLoginUsuarios={setLoginUsuarios}
            />
            <div className="formulario-input">
              <p>
                ¿No tienes una cuenta? <a href="Registro">Regístrate</a>{" "}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
